import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, CheckSquare, CalendarDays, BookOpen, Settings } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', label: 'Home', icon: Home },
    { path: '/circles', label: 'Squad', icon: Users },
    { path: '/tasks', label: 'Tasks', icon: CheckSquare },
    { path: '/resources', label: 'Library', icon: BookOpen },
    { path: '/calendar', label: 'Calendar', icon: CalendarDays },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') return location.pathname === '/dashboard';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-xl border-t border-border"
      style={{ boxShadow: '0 -4px 24px rgba(0,0,0,0.03)', paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="bottom-nav"
    >
      <div className="max-w-lg mx-auto flex items-center justify-around px-1 py-2">
        {navItems.map((item) => {
          const active = isActive(item.path);
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`flex flex-col items-center gap-1 px-1.5 sm:px-3 py-1.5 rounded-xl transition-all duration-200 flex-1 min-w-0 ${
                active
                  ? 'text-cyan-600 dark:text-cyan-400'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon
                className={`w-[22px] h-[22px] transition-all duration-200 ${active ? 'stroke-[2.5]' : 'stroke-[1.8]'}`}
                fill={active ? 'currentColor' : 'none'}
                fillOpacity={active ? 0.1 : 0}
              />
              <span className={`text-[10px] leading-none truncate max-w-full ${active ? 'font-bold' : 'font-medium'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
